/**
 * @generated SignedSource<<80f771c855cc9e1e51f174efcdc70921>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserCardNew_BadgeLink$data = {
  readonly guild: {
    readonly name: string;
    readonly slugId: string;
    readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
  } | null | undefined;
  readonly membershipLevel: GuildMembershipLevel;
  readonly " $fragmentType": "UserCardNew_BadgeLink";
};
export type UserCardNew_BadgeLink$key = {
  readonly " $data"?: UserCardNew_BadgeLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_BadgeLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCardNew_BadgeLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipLevel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Guild",
      "kind": "LinkedField",
      "name": "guild",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slugId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GuildPrimaryPhotoNew_guild"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildMembership",
  "abstractKey": null
};

(node as any).hash = "ea9935c15cdbe176dc96aa866860ae95";

export default node;
